import script from "./SettingsPageToolbar.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingsPageToolbar.vue?vue&type=script&setup=true&lang=js"

import "./SettingsPageToolbar.vue?vue&type=style&index=0&id=4b02d093&lang=less"

const __exports__ = script;

export default __exports__